<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Request New Picture
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div
      v-if="gettingNameplateLogs"
      class="ac-body-container"
    >
      <div class="loading-container">
        <img
          src="@shared/assets/img/general/loading.svg"
          alt="loading"
        >
      </div>
    </div>
    <div
      v-else
      class="ac-body-container"
    >
      <div class="ac-cancel-warning">
        Send a new picture request to {{ customer.firstName }} {{ customer.lastName }}?
      </div>
      <div
        v-if="latestNameplateLog.logDate"
        class="ac-cancel-warning"
      >
        Notification last sent: <b>{{ formattedDate(latestNameplateLog.logDate) }}</b>.
      </div>
      <ProcessOverlay
        :show="requestingNameplate"
        text="Requesting Nameplate"
        overlayClass="ac-overlay"
      />
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="requestNameplate()"
      >
        Request New Picture
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'RequestNameplate',
  components: {
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  mounted() {
    this.$store.dispatch('getNameplateRequestEvents');
  },
  methods: {
    async requestNameplate() {
      await this.$store.dispatch('requestNameplatePhoto');
      this.toggleActionModal(false);
    },
    formattedDate(date) {
      if (date) {
        return moment(date).format('llll');
      }
      return 'NA';
    },
  },
};
</script>

<style scoped></style>
